import { Tooltip } from "@material-ui/core";
import React from "react";
import { useDispatch } from "react-redux";

import SubmitHoursModal from "../modals/SubmitHoursModal";
import { openModal } from "../../../../actions/shared/uiActions";
import Button from "../../../forms/custom/Button";

export default function SubmitHoursButton({
  overrideStyle,
  overloadedClasses,
  candidate,
  initialPayPeriodId,
  setSubmitted,
  disputedAt,
}) {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(
      openModal(
        <SubmitHoursModal
          candidateId={candidate.id}
          {...{ setSubmitted, initialPayPeriodId }}
        />
      )
    );
  };

  return (
    <Button
      variant="primary"
      color="blue"
      onClick={handleClick}
      style={overrideStyle || {}}
      overloadedClasses={overloadedClasses}
      data-cy="submit-hours-button"
    >
      {disputedAt ? "Edit" : "Add"} Hours
    </Button>
  );
}
